




























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { getCurrentGroup, getParentRoute, getVisibleGroups } from '@/router';
import { Group } from '@/router/group.model';

import BusinessMenu from '@/componentsV2/molecules/BusinessMenu/BusinessMenu.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import LeftBarNavGroup from './components/LeftBarNavGroup.vue';
import LeftBarNotificationArrow from '@/componentsV2/molecules/LeftBarNotificationArrow/LeftBarNotificationArrow.vue';

import { isRootUser } from '@/utils/auth';
import refreshBusinessInformation from '@/utils/refresh-business-information';
import { LeftBarNotificationProp } from '@/store/modules/topBarTypes';
import segmentIo from '@/utils/segment.io';
import eventBus from '@/utils/eventBus';
import CloseIcon from '@/components/icons/Close.vue';

let notificationRemoveTimeout: NodeJS.Timeout;
let notificationTimeout: NodeJS.Timeout;

@Component({
  components: {
    LeftBarNavGroup,
    LeftBarNotificationArrow,
    Typography,
    BusinessMenu,
    CloseIcon
  }
})
export default class LeftBar extends Vue {
  @Prop(Group) readonly group: Group | undefined;
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop({ default: false }) mobileTabs?: boolean;

  notification: LeftBarNotificationProp = {} as LeftBarNotificationProp;

  rootUser: boolean = false;
  opened: boolean = false;

  defaultCollapsedGroup = 'my-tools';

  groupCollapsedId = '';
  groupActivedId = '';
  focusedId = '';

  get navbarRoutes() {
    const group = this.group || getCurrentGroup();

    if (!group) {
      return [];
    }

    const visibleRoutes = group.getVisibleRoutes();

    return visibleRoutes.length > 0 || this.viewOnly ? visibleRoutes : [];
  }

  get navbarGroups() {
    return getVisibleGroups().filter(group => group.id !== 'home');
  }

  get leftBarVisible() {
    const hideLeftBar =
      this.$route.meta.navbar && this.$route.meta.navbar.hideLeftBar;
    const leftBarVisible =
      !hideLeftBar && (this.navbarRoutes.length > 0 || this.viewOnly);

    if (leftBarVisible && this.$mobileCheck()) {
      return this.opened;
    }

    return leftBarVisible;
  }

  @Watch('$route')
  onRouteChange() {
    this.resetNotification();

    this.groupCollapsedId = this.getCollapsedGroupId();

    this.reloadCollapseGroup();
  }

  clickCollapse(id: string) {
    const groupRouteId = this.getCollapsedGroupId();

    if (this.groupCollapsedId === id) {
      this.focusedId = groupRouteId;
    } else {
      this.focusedId = id;
    }

    this.groupCollapsedId = this.groupCollapsedId === id ? '' : id;
  }

  changeFocusedId(id: string) {
    this.focusedId = id;
    this.updateActivedGroupId();
  }

  changeGroupCollapsedId(id: string) {
    this.groupCollapsedId = id;
  }

  clickRoute(id: string) {
    this.focusedId = id;
    this.updateActivedGroupId();
    this.toggleLeftBarMobile(false);
  }

  getCollapsedGroupId() {
    const group = this.group || getCurrentGroup();

    if (!group) return '';

    let id = group && group.id;
    if (group.meta.$group) id = group.meta.$group.id;

    if (id === 'home') return this.defaultCollapsedGroup;

    return id;
  }

  resetNotification() {
    this.notification = {} as LeftBarNotificationProp;

    if (notificationRemoveTimeout) clearTimeout(notificationRemoveTimeout);
  }

  showNotificationOnNavItem(notificationData: LeftBarNotificationProp) {
    if (notificationTimeout) clearTimeout(notificationTimeout);
    this.groupCollapsedId = notificationData.groupId;
    this.focusedId = notificationData.subGroupId || notificationData.groupId;

    notificationTimeout = setTimeout(() => {
      this.notification = notificationData;
    }, 1000);

    notificationRemoveTimeout = setTimeout(() => {
      this.resetNotification();
    }, 6000); // 6s
  }

  handleNotificationClick({
    link,
    title,
    trackingTitle,
    groupId
  }: LeftBarNotificationProp) {
    segmentIo.track('Tip Click', {
      tip: trackingTitle || title,
      action: 'click',
      module: groupId
    });

    this.resetNotification();
    this.$router.push(link);
  }

  getFocusedId() {
    if (this.$route.meta.$group && this.$route.meta.$group.routes.length <= 1) {
      if (this.$route.meta.$group.id === 'home')
        return this.defaultCollapsedGroup;

      return this.$route.meta.$group.id;
    }

    return getParentRoute().name || '';
  }

  updateActivedGroupId() {
    if (!this.$route.meta.$group) return '';
    setTimeout(() => {
      this.groupActivedId = this.$route.meta.$group.id;
    });
  }

  reloadCollapseGroup() {
    this.focusedId = this.getFocusedId();
    this.updateActivedGroupId();
  }

  closeMenu() {
    this.toggleLeftBarMobile(false);
  }

  toggleLeftBarMobile(value: boolean) {
    this.opened = value;
  }

  @Watch('navbarRoutes', { immediate: true })
  emitShowLeftbar() {
    this.$emit('showSideMenu', this.leftBarVisible);
  }

  @Watch('opened')
  changedOpened() {
    if (!this.opened) {
      eventBus.$emit('enableScroll');
    } else {
      eventBus.$emit('disableScroll');
    }
  }

  beforeDestroy() {
    this.$emit('showSideMenu', false);
    eventBus.$off('showNotificationOnNavItem', this.showNotificationOnNavItem);
    eventBus.$off('toggleLeftBarMobile', this.toggleLeftBarMobile);
    eventBus.$off('leftBarCollapseGroup', this.changeGroupCollapsedId);
    this.resetNotification();
  }

  mounted() {
    eventBus.$on('leftBarCollapseGroup', this.changeGroupCollapsedId);
    eventBus.$on('showNotificationOnNavItem', this.showNotificationOnNavItem);
    eventBus.$on('toggleLeftBarMobile', this.toggleLeftBarMobile);
  }

  created() {
    this.reloadCollapseGroup();
    this.groupCollapsedId = this.getCollapsedGroupId();
    this.rootUser = isRootUser();

    if (!this.rootUser) {
      refreshBusinessInformation();
    }
  }
}
